import React from "react";
import PropTypes from "prop-types";
import compose from "recompose/compose";
import classNames from "classnames";
import withProps from "recompose/withProps";
import { FormattedMessage } from "react-intl";
import Icon from "theme/components/atoms/Icon";
import withFormHandlers from "theme/components/atoms/Form/Input/withFormHandlers";
import BaseInput from "theme/components/atoms/Form/Input/BaseInput";

const Select = (props) => {
  const {
    getErrors,
    isValid,
    isPristine,
    isDirty,
    value,
    placeholder,
    options,
    onChange,
    onBlur,
    ...rest
  } = props;
  const errors = getErrors();

  const classes = classNames("select-input", {
    "select-input--invalid": getErrors().length,
    "select-input--valid": isValid(),
  });

  return (
    <BaseInput
      input={
        <div className={classes}>
          <select
            {...rest}
            value={value}
            onChange={(event) => {
              onChange(event);
            }}
          >
            {placeholder && (
              <option
                value=""
                disabled={props.required}
                hidden={props.required}
              >
                {placeholder}
              </option>
            )}
            {options.map((option) => {
              return (
                <option
                  key={option.value}
                  value={option.value}
                  disabled={option.disabled}
                >
                  {option.label}
                </option>
              );
            })}
          </select>
          <Icon icon="chevron-right" title="" size="small" />
        </div>
      }
      help={props.help}
      errors={errors}
      {...props.baseInputProps}
    />
  );
};

Select.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string.isRequired,
    }).isRequired
  ),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default compose(
  withProps((props) => ({
    validationError: (
      <FormattedMessage
        id="components.atoms.Form.Input.Select.requiredError"
        defaultMessage="You must select an option"
      />
    ),
    value: props.value,
    options: props.options,
  })),
  withFormHandlers({
    dirtyOnChange: true,
    getValueFromProps: (props) => props.value,
    defaultGetPropsFromValue: (value) => ({
      value: value,
    }),
  })
)(Select);
